import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(16,16,16,0.9)",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#f5f5f5",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </div>
  );
}

export default App;
